/* eslint-disable react/display-name */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconPowertrainGroup } from 'svgIcons/MotionPortalIcons';
import { iconCondition } from '../helpers';
import TooltipTitleComponent from '../TooltipTitleComponent';
import { MAX_CHAR_LENGTH } from '../constants';

const PowertrainOverviewTitle = React.memo(({ item, isHorizontalScrollActive, leftPanelSize, index }) => {
    const { t: translate } = useTranslation();
    const calculateTotalAssetsByCondition = (powertrain, condition) => {
        return powertrain?.assets?.filter((asset) => asset?.condition === condition)?.length || 0;
    };

    // Memoize the title content to avoid recalculating on every render
    const titleContent = useMemo(() => {
        const poorAssets = calculateTotalAssetsByCondition(item, 'Poor');
        const tolerableAssets = calculateTotalAssetsByCondition(item, 'Tolerable');
        const unknownAssets = calculateTotalAssetsByCondition(item, 'Unknown');
        const isLengthyTitle = item?.powertrainName?.length > MAX_CHAR_LENGTH;
        const isLeftPanelClosed = leftPanelSize > 50;
        return (
            <div className={`item-name powertrain__cell-fixed ${isHorizontalScrollActive ? 'horizontal-scroll-active' : ''}`}>
                <div className='asset-condition-icon'>
                    <span className={`asset-condition ${iconCondition(item?.condition)}`}></span>
                </div>
                <div className='item-icon'>
                    <IconPowertrainGroup />
                </div>
                <div className={`name d-flex ${isLengthyTitle ? '' : 'text-truncate'}`}>
                    {isLengthyTitle ?
                        <TooltipTitleComponent index={index} title={item?.powertrainName} leftPanelSize={leftPanelSize} count={item?.assets?.length} />
                        : <><div className='text-truncate'>{item?.powertrainName}</div> {`(${item?.assets?.length})`}</>}
                </div>
                {isLeftPanelClosed && <>
                    <div className='conditions-item'>{`${translate('ABB.Powertrain.Frontend.poorLabel')}: ${poorAssets}`}</div>
                    <div className='conditions-item'>{`${translate('ABB.Powertrain.Frontend.tolerableLabel')}: ${tolerableAssets}`}</div>
                    <div className='conditions-item'>{`${translate('ABB.Powertrain.Frontend.unknownLabel')}: ${unknownAssets}`}</div>
                </>}
            </div>
        );
    }, [item?.powertrainName, item?.assets?.length, isHorizontalScrollActive, translate, leftPanelSize]);

    return (
        <>
            {titleContent}
        </>
    );
});

PowertrainOverviewTitle.propTypes = {
    item: PropTypes.shape({
        powertrainName: PropTypes.string,
        assets: PropTypes.array,
        condition: PropTypes.string
    }),
    isHorizontalScrollActive: PropTypes.bool
};

export default PowertrainOverviewTitle;
